import { render, staticRenderFns } from "./SaleShowPage.vue?vue&type=template&id=3bfdc411&scoped=true&"
import script from "./SaleShowPage.vue?vue&type=script&lang=js&"
export * from "./SaleShowPage.vue?vue&type=script&lang=js&"
import style0 from "./SaleShowPage.vue?vue&type=style&index=0&id=3bfdc411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfdc411",
  null
  
)

export default component.exports